export enum MachineCommandsEnum {
  reboot = 'Riavvia il sistema',
  shutdown = 'Spegni il sistema',
  reloadScheduler = 'Ricarica i dati dello scheduler',
  switchOnProjector = 'Accendi il proiettore',
  switchOffProjector = 'Spegni il proiettore',
  switchOnScreen = 'Accendi lo schermo',
  switchOffScreen = 'Spegni lo schermo',
}
